export default __webpack_public_path__ + "static/media/upload-front.6791a5c4.webp";